export default "/images/d38ee8470d339215afd33c0637dca591.avif";